<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
    <g transform="translate(-4 -3)">
     <path d="M10.714,20.444c-0.032,0.823,0.606,1.518,1.429,1.556h7.714c0.823-0.038,1.461-0.733,1.429-1.556v-9.333
      H10.714V20.444z M12.143,12.667h7.714v7.778h-7.714V12.667z M18.5,8.778L17.786,8h-3.572L13.5,8.778H10v1.555h12V8.778H18.5z"/>
    </g>
    </svg>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
svg {
    fill: currentColor;
}
</style>

<script>
export default {
  name: 'delete'
}
</script>
